<script setup lang="ts">
import { computed } from 'vue';
import { UiChip } from '@shopexperts/shared';
import type { AdminExpertClaim } from '@shopexperts/legacy-api';
import { statusChip, getDecisionChip, claimTypeChip } from './claimAppearance';

const props = defineProps<{
  claim: Pick<AdminExpertClaim, 'type' | 'status' | 'decision' | 'decided_by'>;
}>();

const typeChip = computed(() => claimTypeChip[props.claim.type]);
const statusChipDisplay = computed(() => statusChip[props.claim.status]);
const decisionChip = computed(() => getDecisionChip(props.claim));

const statusTooltip = computed(() =>
  props.claim.status === 'verified'
    ? 'The claimant verified their email address'
    : 'Waiting for the claimant to verify their email address',
);

const decisionTooltip = computed(() =>
  decisionChip.value.isAutoRejected
    ? 'Rejected automatically because another claim for this profile was approved'
    : undefined,
);
</script>

<template>
  <div class="flex items-center gap-2 flex-wrap">
    <UiChip
      :text="typeChip.label"
      :variant="typeChip.variant"
      size="xs"
      rounded="small"
      :bg-color-class="typeChip.bgClass"
      :text-color-class="typeChip.textClass"
      class="shrink-0"
    />
    <UiChip
      :text="statusChipDisplay.label"
      :variant="statusChipDisplay.variant"
      size="xs"
      rounded="small"
      :bg-color-class="statusChipDisplay.bgClass"
      :text-color-class="statusChipDisplay.textClass"
      :tooltip="statusTooltip"
      class="shrink-0"
    />
    <UiChip
      :text="decisionChip.label"
      :variant="decisionChip.variant"
      size="xs"
      rounded="small"
      :bg-color-class="decisionChip.bgClass"
      :text-color-class="decisionChip.textClass"
      :tooltip="decisionTooltip"
      class="shrink-0"
    />
  </div>
</template>
